<template>
  <Teleport to="body">
    <div class="absolute top-0 left-0 w-full h-full z-50 bg-white flex flex-col" v-if="model">
      <div class="p-4 flex justify-between items-center">
        <div>
          <NuxtLink :to="localePath('/')">
            <IconsLogo />
          </NuxtLink>
        </div>
        <div class="cursor-pointer" @click="model = false">
          <IconsBurger open />
        </div>
      </div>
      <div class="flex flex-grow justify-center">
        <Menu v-model="model" />
      </div>
      <div class="mb-[50px] flex justify-center">
        <Btn @click="onButtonClicked" small>
          {{ t('b2b.header.button') }}
        </Btn>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import IconsLogo from "~/components/icons/Logo.vue";
import IconsBurger from "~/components/icons/Burger.vue";
import Menu from "~/components/ui/Menu.vue";
import Btn from "~/components/ui/Btn.vue";

const model = defineModel()
const localePath = useLocalePath()
const {t} = useI18n()
const router = useRouter();

const onButtonClicked = () => {
  model.value = false;
  router.push(localePath({path: '/', hash: '#feedback'}));
}
</script>


